import { Services } from "appworks/services/services";
import { SoundService } from "appworks/services/sound/sound-service";

export function AgsSoundSetup() {

    // Freespins Music
    Services.get(SoundService).registerPlay("start_freespins", { id: "freespin_music", music: true, loop: true });
    Services.get(SoundService).registerPlay("enter_scene_Prompts_freespinswin", { id: "freespin_intro", music: true });
    Services.get(SoundService).registerStop("exit_scene_Prompts_freespinssummary", { id: "freespin_music" });
    Services.get(SoundService).registerTerminator("freespin_outro", "freespin_music");

    // Freespins SFX
    Services.get(SoundService).registerPlay("ringup1", { id: "freespin_ringup" });
    Services.get(SoundService).registerTerminator("freespin_ringup_climax", "freespin_ringup");
    Services.get(SoundService).registerPlay("bonus_bell", { id: "bonus_bell" });
    Services.get(SoundService).registerPlay("prog_bell", { id: "prog_bell" });
    Services.get(SoundService).registerPlay("freespins_picked", { id: "freespin_selection_pick" });
    Services.get(SoundService).registerPlay("reels_expanding", { id: "freespin_expansion" });

    // Reels
    Services.get(SoundService).registerPlay("reel_0_spinner_stage_complete_fullstop", { id: "reel_stop1" });
    Services.get(SoundService).registerPlay("reel_1_spinner_stage_complete_fullstop", { id: "reel_stop2" });
    Services.get(SoundService).registerPlay("reel_2_spinner_stage_complete_fullstop", { id: "reel_stop3" });
    Services.get(SoundService).registerPlay("reel_3_spinner_stage_complete_fullstop", { id: "reel_stop4" });
    Services.get(SoundService).registerPlay("reel_4_spinner_stage_complete_fullstop", { id: "reel_stop5" });
    Services.get(SoundService).registerPlay("reel_4_spinner_stage_complete_fullstopskip", { id: "reel_stop5" });

    // Symbols
    Services.get(SoundService).registerPlay("symbol_BN_win", { id: "bn" });
    Services.get(SoundService).registerPlay("bonus_BN_land_1", { id: "bonus_marker1" });
    Services.get(SoundService).registerPlay("bonus_BN_land_2", { id: "bonus_marker2" });
    Services.get(SoundService).registerPlay("bonus_BN_land_3", { id: "bonus_marker3" });
    Services.get(SoundService).registerPlay("bonus_BN_land_4", { id: "bonus_marker3" });
    Services.get(SoundService).registerPlay("bonus_BN_land_5", { id: "bonus_marker3" });
    Services.get(SoundService).registerPlay("symbol_H1_win", { id: "h1" });
    Services.get(SoundService).registerPlay("symbol_WW_win", { id: "ww" });
    Services.get(SoundService).registerPlay("symbol_any_win", { id: "universal_symbol_win" });
    Services.get(SoundService).registerPlay("symbol_BN_win", { id: "bn" });

    // UI
    // Services.get(SoundService).registerPlay("default_button_press", { id: "button" });
    Services.get(SoundService).registerPlay("button_press_total_credits_radio_1", { id: "set_bet1" });
    Services.get(SoundService).registerPlay("button_press_total_credits_radio_2", { id: "set_bet2" });
    Services.get(SoundService).registerPlay("button_press_total_credits_radio_3", { id: "set_bet3" });
    Services.get(SoundService).registerPlay("button_press_total_credits_radio_4", { id: "set_bet4" });
    Services.get(SoundService).registerPlay("button_press_total_credits_radio_5", { id: "set_bet5" });
    Services.get(SoundService).registerPlay("button_press_ags_max_bet", { id: "set_bet5" });
    Services.get(SoundService).registerPlay("button_press_credit_size_stepper_up", { id: "denom" });
    Services.get(SoundService).registerPlay("button_press_credit_size_stepper_down", { id: "denom" });
    Services.get(SoundService).registerPlay("button_press_close", { id: "exit" });
    Services.get(SoundService).registerPlay("button_press_sound_toggle_on", { id: "volume_button" });
    Services.get(SoundService).registerPlay("button_press_ui_menu", { id: "game_menu_open" });
    Services.get(SoundService).registerPlay("button_press_close", { id: "game_menu_close" });
    Services.get(SoundService).registerPlay("button_press_next", { id: "button" });
    Services.get(SoundService).registerPlay("button_up_spin", { id: "spin_button" });
    Services.get(SoundService).registerPlay("button_press_previous", { id: "button" });
    Services.get(SoundService).registerPlay("button_press_page_1", { id: "button" });
    Services.get(SoundService).registerPlay("button_press_page_2", { id: "button" });
    Services.get(SoundService).registerPlay("button_press_page_3", { id: "button" });
    Services.get(SoundService).registerPlay("button_press_page_4", { id: "button" });
    Services.get(SoundService).registerPlay("button_press_page_5", { id: "button" });
    Services.get(SoundService).registerPlay("button_press_page_6", { id: "button" });
    Services.get(SoundService).registerPlay("button_press_page_7", { id: "button" });
    Services.get(SoundService).registerPlay("button_press_page_8", { id: "button" });
    Services.get(SoundService).registerPlay("button_press_page_9", { id: "button" });
    Services.get(SoundService).registerPlay("button_press_page_10", { id: "button" });
    Services.get(SoundService).registerPlay("button_press_page_11", { id: "button" });
    Services.get(SoundService).registerPlay("button_press_page_12", { id: "button" });
    Services.get(SoundService).registerPlay("button_press_page_13", { id: "button" });

    // Roll up
    Services.get(SoundService).registerPlay("rollup_level1", { id: "level1" });
    Services.get(SoundService).registerPlay("rollup_level2", { id: "level2" });
    Services.get(SoundService).registerPlay("rollup_level3", { id: "level3" });
    Services.get(SoundService).registerPlay("rollup_level4", { id: "level4" });
    Services.get(SoundService).registerPlay("rollup_level5", { id: "level5" });
    Services.get(SoundService).registerPlay("rollup_level6", { id: "level6" });
    Services.get(SoundService).registerPlay("rollup_level7", { id: "level7" });
    Services.get(SoundService).registerPlay("rollup_level8", { id: "level8" });
    Services.get(SoundService).registerPlay("rollup_level9", { id: "level9" });
    Services.get(SoundService).registerPlay("rollup_level10", { id: "level10" });
    Services.get(SoundService).registerPlay("rollup_level11", { id: "level11" });
    Services.get(SoundService).registerPlay("rollup_level12", { id: "level12" });
    Services.get(SoundService).registerPlay("rollup_level13", { id: "level13" });
    Services.get(SoundService).registerPlay("rollup_level14", { id: "level14" });
    Services.get(SoundService).registerPlay("rollup_level15", { id: "level15", music: true });
    Services.get(SoundService).registerStop("cancel_rollup", { id: "level1" });
    Services.get(SoundService).registerStop("cancel_rollup", { id: "level2" });
    Services.get(SoundService).registerStop("cancel_rollup", { id: "level3" });
    Services.get(SoundService).registerStop("cancel_rollup", { id: "level4" });
    Services.get(SoundService).registerStop("cancel_rollup", { id: "level5" });
    Services.get(SoundService).registerStop("cancel_rollup", { id: "level6" });
    Services.get(SoundService).registerStop("cancel_rollup", { id: "level7" });
    Services.get(SoundService).registerStop("cancel_rollup", { id: "level8" });
    Services.get(SoundService).registerStop("cancel_rollup", { id: "level9" });
    Services.get(SoundService).registerStop("cancel_rollup", { id: "level10" });
    Services.get(SoundService).registerStop("cancel_rollup", { id: "level11" });
    Services.get(SoundService).registerStop("cancel_rollup", { id: "level12" });
    Services.get(SoundService).registerStop("cancel_rollup", { id: "level13" });
    Services.get(SoundService).registerStop("cancel_rollup", { id: "level14" });
    Services.get(SoundService).registerStop("cancel_rollup", { id: "level15" });

    Services.get(SoundService).registerStop("cancel_rollup", { id: "freespin_ringup" });
    Services.get(SoundService).registerStop("end_rollup", { id: "level15" });
    Services.get(SoundService).registerStop("end_rollup", { id: "freespin_ringup" });

    Services.get(SoundService).registerPlay("highlight_all_wins", { id: "universal_symbol_win" });
    Services.get(SoundService).registerPlay("bonus_celebration", { id: "universal_symbol_win" });

    // Big wins
    Services.get(SoundService).registerPlay("enter_scene_CelebrationForeground_bigwingem", { id: "big_win", music: true });
    Services.get(SoundService).registerPlay("enter_scene_CelebrationForeground_bigwincoin", { id: "big_win", music: true });
    Services.get(SoundService).registerStop("stopBigWins", { id: "big_win" });
    Services.get(SoundService).registerPlay("stopBigWins", { id: "big_win_outro" });

    // Aliases
    Services.get(SoundService).registerAlias("pick_music_level1", "prog_pick_music");
    Services.get(SoundService).registerAlias("pick_music_level2", "prog_pick_music");
    // Services.get(SoundService).registerAlias("fs_select", "freespin_start");
    Services.get(SoundService).registerAlias("level15", "big_win");
}
